import { RateLimiterMemory } from 'rate-limiter-flexible'

// تحديد 5 محاولات تسجيل دخول كل 15 دقيقة
const loginLimiter = new RateLimiterMemory({
  points: 5,
  duration: 15 * 60, // 15 minutes
})

// تحديد 100 طلب API كل دقيقة
const apiLimiter = new RateLimiterMemory({
  points: 100,
  duration: 60, // 1 minute
})

export const checkLoginLimit = async (email) => {
  try {
    await loginLimiter.consume(email)
    return true
  } catch {
    throw new Error('Too many login attempts. Try again in 15 minutes.')
  }
}

export const checkApiLimit = async (userId) => {
  try {
    await apiLimiter.consume(userId)
    return true
  } catch {
    throw new Error('Rate limit exceeded. Slow down.')
  }
}
